import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

interface Props {
  spans: number[];
  selected?: boolean;
}

const ICON_HEIGHT = 22;
const ICON_WIDTH = 28;
const GAP = 2;
const BAR_RADIUS = 1;

export default function ColumnDistributionIcon({ spans, selected = false }: Props) {
  const theme = useTheme();
  const fill = selected ? theme.palette.primary.main : theme.palette.text.secondary;
  const total = spans.reduce((sum, span) => sum + span, 0);
  const innerWidth = ICON_WIDTH - GAP * (spans.length - 1);
  let offset = 0;

  return (
    <Box
      component="svg"
      viewBox={`0 0 ${ICON_WIDTH} ${ICON_HEIGHT}`}
      width={ICON_WIDTH}
      height={ICON_HEIGHT}
      aria-hidden
      sx={{ display: 'block', flexShrink: 0 }}
    >
      {spans.map((span, index) => {
        const width = (span / total) * innerWidth;
        const x = offset;
        offset += width + GAP;
        return (
          <rect
            key={`${span}-${index}`}
            x={x}
            y={0}
            width={width}
            height={ICON_HEIGHT}
            rx={BAR_RADIUS}
            fill={fill}
          />
        );
      })}
    </Box>
  );
}
